var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckSign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8897 9.42004L12.0264 11.5168C11.9726 11.6475 12.0026 11.7976 12.1025 11.8975C12.2024 11.9974 12.3525 12.0274 12.4832 11.9736L14.5799 11.1103L12.8897 9.42004Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8053 2.20498C20.532 1.93167 20.0888 1.93167 19.8155 2.20498L19.0254 2.99509L18.9723 2.94194C18.4353 2.40497 17.5647 2.40497 17.0277 2.94194L15.7348 4.23483C15.5884 4.38128 15.5884 4.61872 15.7348 4.76517C15.8813 4.91161 16.1187 4.91161 16.2652 4.76517L17.5581 3.47227C17.8021 3.22819 18.1979 3.22819 18.4419 3.47227L18.4951 3.52542L13.2755 8.7452L15.2548 10.7245L21.795 4.18448C22.0683 3.91117 22.0683 3.46805 21.795 3.19473L20.8053 2.20498Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4 5H14.1926C14.2397 5.17102 14.3116 5.33667 14.408 5.49132L12.8401 7.05932C12.7339 7.02093 12.6194 7 12.5 7H5C4.44772 7 4 7.44772 4 8C4 8.55229 4.44772 9 5 9H11.4471L11.4314 9.02232L10.6394 10.9457C10.632 10.9637 10.6248 10.9818 10.618 11H5C4.44772 11 4 11.4477 4 12C4 12.5523 4.44772 13 5 13H11.0851C11.6126 13.4945 12.3824 13.6373 13.0543 13.3607L14.9777 12.5687L16.8458 11.2548L21.8535 6.2473C21.948 6.47964 22 6.73375 22 7V17C22 18.1046 21.1046 19 20 19H4C2.89543 19 2 18.1046 2 17V7C2 5.89543 2.89543 5 4 5ZM4 16C4 16.5523 4.44772 17 5 17H19C19.5523 17 20 16.5523 20 16C20 15.4477 19.5523 15 19 15H5C4.44772 15 4 15.4477 4 16Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckSign);
export default __webpack_public_path__ + "static/media/check-sign.7edeef4afc2fb67b6f88e652e04d42b0.svg";
export { ForwardRef as ReactComponent };